<template>
  <div>
    <div class="list">
      <div
        class="list-item pointer flex flex-top"
        v-for="(item, index) in data"
        :key="index"
        @click="fileDetailsClick(item.standardFileId)"
      >
        <div class="list-item-index">{{ index + 1 }}</div>
        <div class="flex-1 ellipsis">{{ item.standardFileTitle }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["token"]),
  },
  methods: {
    async fileDetailsClick(id) {
      if (!this.token) {
        return this.$store.dispatch("login");
      }
      const { href } = this.$router.resolve({
        path: "/standardFileDetail",
        query: {
          id,
        },
      });
      window.open(href);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.list {
  &-item {
    border-top: 1px solid #e6e6e6;
    padding: 10px;
    &:hover {
      color: $theme-color;
    }
    &-index {
      width: 24px;
      height: 24px;
      line-height: 24px;
      border-radius: 12px;
      margin-right: 10px;
      background: $theme-color;
      color: #fff;
      text-align: center;
    }
  }
}
</style>
